var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriveFlagged(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#FDF7E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#F7D780"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11890_7585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14.9984C7 14.3309 7.41 13.7584 7.99 13.5184L8.87 11.0059C9.2075 10.0434 10.115 9.39844 11.135 9.39844H15.665C16.685 9.39844 17.5925 10.0434 17.93 11.0059L18.7825 13.4409C16.645 13.7409 15 15.5784 15 17.7984C15 18.0709 15.025 18.3384 15.0725 18.5984H9.4V19.7984C9.4 20.2409 9.0425 20.5984 8.6 20.5984H7.8C7.3575 20.5984 7 20.2409 7 19.7984V18.5984V14.9984ZM8.6 15.7984C8.6 16.2409 8.9575 16.5984 9.4 16.5984C9.8425 16.5984 10.2 16.2409 10.2 15.7984C10.2 15.3559 9.8425 14.9984 9.4 14.9984C8.9575 14.9984 8.6 15.3559 8.6 15.7984ZM9.7275 13.3984H17.0725L16.42 11.5334C16.3075 11.2134 16.005 10.9984 15.665 10.9984H11.135C10.795 10.9984 10.4925 11.2134 10.38 11.5334L9.7275 13.3984ZM15.8 17.7984C15.8 15.8109 17.4125 14.1984 19.4 14.1984C21.3875 14.1984 23 15.8109 23 17.7984C23 19.7859 21.3875 21.3984 19.4 21.3984C17.4125 21.3984 15.8 19.7859 15.8 17.7984ZM18.8 19.5984C18.8 19.9309 19.0675 20.1984 19.4 20.1984C19.7325 20.1984 20 19.9309 20 19.5984C20 19.2659 19.7325 18.9984 19.4 18.9984C19.0675 18.9984 18.8 19.2659 18.8 19.5984ZM19 15.7984V17.7984C19 18.0184 19.18 18.1984 19.4 18.1984C19.62 18.1984 19.8 18.0184 19.8 17.7984V15.7984C19.8 15.5784 19.62 15.3984 19.4 15.3984C19.18 15.3984 19 15.5784 19 15.7984Z",
    fill: "#F0AE00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11890_7585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12.8,
    fill: "white",
    transform: "translate(7 8.59961)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveFlagged);
export default __webpack_public_path__ + "static/media/drive-flagged.7093aeb378e144ab40592f7de08af74d.svg";
export { ForwardRef as ReactComponent };